var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBmp = function SvgBmp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.5 10.5 18 6h4.5zM4.5 13h13.6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 9,
    x: 2.1,
    y: 11,
    fill: "#21852B",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.668 17.5v-4h1.601q.442 0 .737.13a1 1 0 0 1 .443.364.96.96 0 0 1 .148.531.81.81 0 0 1-.352.701 1.1 1.1 0 0 1-.37.159v.039q.228.01.428.129t.326.334a1 1 0 0 1 .125.508q0 .318-.158.568a1.07 1.07 0 0 1-.463.392 1.8 1.8 0 0 1-.756.145zm.845-.691h.69q.353 0 .516-.135a.45.45 0 0 0 .162-.363.54.54 0 0 0-.08-.293.54.54 0 0 0-.229-.2.8.8 0 0 0-.35-.072h-.709zm0-1.635h.627q.175 0 .309-.06a.5.5 0 0 0 .215-.177.46.46 0 0 0 .08-.271.44.44 0 0 0-.154-.35q-.152-.132-.434-.132h-.643zM8.47 13.5h1.043l1.101 2.688h.047l1.102-2.688h1.043v4h-.82v-2.604h-.034l-1.035 2.584h-.558l-1.035-2.593h-.034V17.5h-.82zm5.198 4v-4h1.578q.455 0 .775.174.321.172.489.478.17.306.17.704t-.172.703q-.172.304-.498.474-.325.17-.786.17h-1.006v-.678h.87a.85.85 0 0 0 .402-.084.56.56 0 0 0 .238-.236.74.74 0 0 0 .08-.35.7.7 0 0 0-.08-.347.54.54 0 0 0-.238-.233.9.9 0 0 0-.406-.084h-.57V17.5z"
  })));
};
export default SvgBmp;